<template>
  <div class="container">
    <div class="wrap">
      <div class="page-t">摄影采风</div>
      <div class="list-con">
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item,index) in list" :key="index">
            <caifengItem :itemData="item" showSta></caifengItem>
          </el-col>
        </el-row>
        <!-- 结果为空 -->
        <el-empty class="empty-con" description="暂无摄影采风" :image-size="180" v-if="list.length == 0">
          <img class="img" src="../assets/images/default-list.png" slot="image"/>
        </el-empty>
        <!-- 分页 -->
        <el-pagination 
          class="pagination" 
          background 
          layout="prev, pager, next" 
          :total="totalNum"
          :page-size="pageSize"
          hide-on-single-page
          @current-change="changePage"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import caifengItem from '@/components/item/caifengItem';
export default {
  components: {
    caifengItem,
  },
  data() {
    return {
      curPage:1,
      totalNum:0,
      pageSize:20,
      activeSort:'最新',
      list:[
        // {
        //   id:1,
        //   img:'https://dy-allimage.oss-cn-hangzhou.aliyuncs.com/uploads/ed0/b08/ed0b0880be88a61a438ce3877ea36c85.jpg',
        //   title:'第一届“绿水青山·美丽中华”全国生态摄影大赛秋季采风团',
        //   deadline:'2023-04-11 12:00:00',
        // }
      ],
    };
  },
  computed: {
    
  },
  mounted() {
    this.getRows();
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    //分页
    changePage(e){
      this.curPage = e;
      this.getRows();
    },
    //获取列表数据
    getRows(){
      const loading = this.$loading({target:'.list-con',});
      let params = {offset: (this.curPage - 1)  * this.pageSize, length: this.pageSize};
      this.$axios.api.caifengList(params, (res) => {
        if (res.code == 200) {
          loading.close();
          this.totalNum = res.data.total;
          this.list = res.data.list;
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.wrap{
  align-items: flex-start;
}

</style>
